<template>
    <select
        @change="valueChanged"
        class="form-control"
        :value="value"
        :required="required"
    >
        <option
            v-if="value === ''"
            value=""
            v-text="'--Select---'"
            :selected="value === ''"
        ></option>
        <optgroup v-for="(groupOptions, group) in options" :key="group" :label="group">
            <option
                v-for="option in groupOptions"
                :key="option[valueKey]"
                :value="option[valueKey]"
                v-text="option[labelKey]"
                :disabled="option.disabled !== undefined ? option.disabled : false"
                :selected="value === option[valueKey]"
            ></option>
        </optgroup>
    </select>
</template>

<script>
export default {
    name: 'GroupSelectInput',

    props: {
        labelKey: {
            default: 'name',
            required: false,
            type: String,
        },
        options: {
            required: true,
            type: Object,
            default: {},
        },
        placeholder: {
            default: null,
            required: false,
            type: String,
        },
        required: {
            default: false,
            required: false,
            type: Boolean,
        },
        value: {
            default: null,
            required: false,
            type: [String, Number],
        },
        valueKey: {
            default: 'id',
            required: false,
            type: String,
        },
    },

    methods: {
        valueChanged(e) {
            this.$emit('input', e.target.value);
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Forms/InputFields/GroupSelect.vue